import React, { useEffect, useState } from "react";
import Modal from "../../../components/modal";
import axios from "axios";
import { API_URL } from "../../../utils/constant";
import Swal from "sweetalert2";
import { fetchBranchUsers } from "../../../slices/company/branchUserSlice";
import { useDispatch, useSelector } from "react-redux";

const CreateTaskModal = ({ show, onClose, heading, initialData = {}, onSubmit, customers, typetask, products, rawProducts }) => {
    const getStatusColor = (status) => {
        switch (status) {
            case "pending":
                return "bg-danger text-white";
            case "completed":
                return "bg-success text-white";
            case "in progress":
                return "bg-primary text-white";
            default:
                return "bg-grey text-black";
        }
    };

    console.log('typetask', typetask);

    return (
        <Modal show={show} onClose={onClose} heading={heading}>
            <table className="table w-full border-collapse border border-gray-300">
                <thead>
                    <tr className="bg-gray-200">
                        <th className="border border-gray-300 p-2">#</th>
                        <th className="border border-gray-300 p-2">Name</th>
                        <th className="border border-gray-300 p-2">Priority</th>
                        <th className="border border-gray-300 p-2">Start Date</th>
                        <th className="border border-gray-300 p-2">End Date</th>
                        <th className="border border-gray-300 p-2">Status</th>
                    </tr>
                </thead>
                <tbody>
                    {initialData && initialData.Tasks != null && initialData.Tasks.map((task, index) => (
                        !typetask || typetask == task.task_for && (
                            <tr key={task.id} className="border border-gray-300">
                                <td className="border border-gray-300 p-2">{index + 1}</td>
                                <td className="border border-gray-300 p-2">{task.name}</td>
                                <td className="border border-gray-300 p-2">{task.priority}</td>
                                <td className="border border-gray-300 p-2">
                                    {new Date(task.start_date).toLocaleDateString()}
                                </td>
                                <td className="border border-gray-300 p-2">
                                    {new Date(task.end_date).toLocaleDateString()}
                                </td>
                                <td className="border border-gray-300 p-2">
                                    <span className={`px-2 py-1 rounded ${getStatusColor(task.status)}`}>
                                        {task.status}
                                    </span>
                                </td>
                            </tr>
                        )
                    ))}
                </tbody>
            </table>
        </Modal>
    );
};

export default CreateTaskModal;
